import { Tag } from '@shared/interfaces/project/tag.interface';
import { User } from '@shared/models/user/user.model';

export class Event {
  id?: number;
  image?: any;
  name: string;
  startAt: string;
  start_at?: string;
  end_at?: string;
  startTime?: string;
  endAt: string;
  endTime?: string;
  edited_at?: string;
  description: string;
  invitations: [];
  invitation: any;
  participant_counter: number;
  participant_guest: number;
  organization: any;
  type: string;
  theme: any;
  status: number;
  address: {
    name: string;
    city: string;
    voivodeship: string;
    country: string;
    zipcode: string;
    street: string;
    longitude: number;
    latitude: number;
    continent: string;
  };
  categories: Tag[];
  counter?: number;
  user?: User;
  file?: any;
  created_at?: string;
  is_project_linked?: boolean;

  constructor(data?: any) {
    Object.assign(this, data);
  }
}
